var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.86279C9.87225 4.86279 8.85045 5.03517 7.93193 5.31072C7.43595 5.45952 6.91335 5.17812 6.76455 4.68218C6.61575 4.18625 6.89723 3.66361 7.39313 3.51483C8.47463 3.19039 9.67778 2.98779 11 2.98779C17.0351 2.98779 21.9375 7.8374 21.9375 13.8378C21.9375 19.8382 17.0351 24.6878 11 24.6878C4.96493 24.6878 0.0625 19.8382 0.0625 13.8378C0.0625 11.6061 0.747468 9.52467 1.91028 7.80102C2.19984 7.3718 2.78253 7.25855 3.21176 7.54812C3.64095 7.8377 3.7542 8.42037 3.46466 8.8496C2.50247 10.2759 1.9375 11.9945 1.9375 13.8378C1.9375 18.7874 5.98508 22.8128 11 22.8128C16.0149 22.8128 20.0625 18.7874 20.0625 13.8378C20.0625 8.88822 16.0149 4.86279 11 4.86279Z",
    fill: "#BF360C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94809 0.463582C10.3824 0.74535 10.5062 1.3259 10.2244 1.76029L8.63641 4.2085L11.1078 5.79932C11.5432 6.07952 11.6689 6.65964 11.3887 7.09501C11.1084 7.53039 10.5283 7.65617 10.093 7.37589L6.83049 5.27589C6.62094 5.14104 6.47371 4.92827 6.42136 4.68462C6.36894 4.44098 6.41574 4.18651 6.55134 3.97743L8.65134 0.739935C8.93311 0.305542 9.51369 0.181822 9.94809 0.463582Z",
    fill: "#BF360C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.4f0b22f3ac3ff6b849808fbcbf844cec.svg";
export { ForwardRef as ReactComponent };